import { InfoReturnOptions } from '../receivement/ReceivementTypes'

export interface SwapOrReturnState {
  swapOrReturnInvoices: SwapOrReturnInvoice[]
  filteredStatus: string[]
  swapOrReturnData: SwapOrReturnData
  selectedProducts: Product[]
  requestTypeId?: SwapOrReturnTypeIds
  typeAction?: TypeAction
  requestTagInfo: RequestTagInfo[]
  swapOrReturnToResolveIds: number[]
  swapOrReturnToResolveData: SwapOrReturnToResolveData | null
  swapOrReturnSearchData?: GetSwapsOrReturnsPayload
  pendingsToPrint?: PendingsToPrint
  pagination: Pagination
}

export interface SwapOrReturnInvoice {
  id: number
  supplierName: string
  invoiceNumber: number
  invoiceAccessKey: string
  volume: number
  type: string
  status: string
  createdBy: string
  createdAt: Date
}

export interface Pagination {
  currentPage: number
  perPage: number
  totalItems: number
  totalPages: number
}
export interface SwapOrReturnInvoiceData {
  data: SwapOrReturnInvoice[]
  pagination: Pagination
}

export enum GenericApiErrors {
  Failed,
}

export interface GetSwapsOrReturnsPayload {
  fulfillmentCenterId: number
  supplierName: string
  invoice: string
  typesIds: number[]
  status: string[]
  page: number
  perPage: number
  order?: string
  orderBy?: string | number
}

export enum SwapOrReturnTypesEnum {
  SWAP = 'Troca',
  RETURN = 'Devolução'
}

export enum SwapOrReturnTypeIds {
  RETURN = 1,
  SWAP = 2,
}

export enum SwapOrReturnTypeNames {
  RETURN = 'return',
  SWAP = 'swap',
}

export enum ActionModalTypes {
  CREATE = 'create',
  EDIT = 'edit',
}

export enum GetSwapsOrReturnsStatusEnum {
  OPEN = 'Aberto',
  IN_RESOLUTION = 'Em resolução',
  WAITING_RELEASE = 'Aguardando liberação',
  RESOLVED = 'Resolvido',
  CANCELED = 'Cancelado'
}

export enum SwapOrReturnStatusEnum {
  CREATED = 'Criado',
  PENDING = 'Pendente',
  IN_RESOLUTION = 'Em resolução',
  WAITING_RELEASE = 'Aguardando liberação',
  RESOLVED = 'Resolvido',
  CANCELED = 'Cancelado'
}

export enum TypeActionTextEnum {
  READ_ONLY = 'Somente leitura',
  CREATE_SWAP = 'Criando troca',
  EDIT_SWAP = 'Editando troca',
  CREATE_RETURN = 'Criando devolução',
  EDIT_RETURN = 'Editando devolução',
}

export type TypeAction = 'CREATE' | 'EDIT'

export interface CancelSwapOrReturnPayload {
  id: number
  onSuccess: () => void
}

export interface ReceivementBatch {
  idBatch: number
  quantity: number
  inputQuantity: number | null
  expirationDate: string
}

export interface Product {
  idModel: number
  productCode: string
  description: string
  totalInvoiceQuantity: number
  availablePendingQuantity: number
  quantityPerBox: number
  inputQuantity?: number
  measureUnit: string
  batches: ReceivementBatch[]
  isQuantityMatch?: boolean
}

export interface Request {
  id: number
  readOnly: boolean
  status: string
  products: Product[]
  availableProductsForAddition: Product[]
}

export interface SwapOrReturnData {
  return: Request | null
  swap: Request | null
  availableProductsForCreation: Product[]
  infoReturnOptions: InfoReturnOptions | null
  invoiceKey: string | null
  invoiceNumber: number | null
  supplierName: string | null
}

export interface SetProperty {
  property: keyof SwapOrReturnState
  value: SwapOrReturnState[keyof SwapOrReturnState]
}

export interface SwapOrReturnModalData {
  show: boolean
  swapOrReturnData: SwapOrReturnData | null
}

export interface GetDataForRequestCreationPayload {
  invoiceKey: string
  setModalData: React.Dispatch<React.SetStateAction<SwapOrReturnModalData>>
}

export interface CreateOrUpdateRequestPayload {
  requestTypeId?: SwapOrReturnTypeIds
  idRequest?: number | null
  invoiceKey: string | null
  products: Product[]
  setShowTagPrinterModal: React.Dispatch<React.SetStateAction<boolean>>
}

export interface RequestTagInfo {
  type: string
  supplier: string
  invoiceNumber: number
  idBatch: number
  skuCode: string
  sku: string
  quantity: number
  quantityUnit: string
  volume: number
  dueDate: string
  operator: string
  reason: string
  fulfillmentCenter: string
  address: string
  printed?: boolean
}

export interface ExpirationBatchToResolve {
  idExpirationBatch: number
  availableQuantity: number
  countedQuantity?: number
  idLocation: number
  address: string
  idLocationType: number
}

export interface ReturnBatchToResolve {
  idRequestItemBatch: number
  idBatch: number
  batchNumber: number
  quantity: number
  countedQuantity?: number
  dueDate: string
  expirationBatches: ExpirationBatchToResolve[]
}

export interface ReceiveBatchToResolve {
  idBatch?: number
  batchNumber?: number
  quantity: number
  dueDate: string
  address?: string
  remove?: boolean
}

export interface ItemToResolve {
  idItem: number
  idModel: number
  productCode: string
  productDescription: string
  packQuantity: number
  returnQuantity: number
  returnBatches: ReturnBatchToResolve[]
  returnQuantityCounted: boolean
  receiveQuantity?: number
  receiveBatches?: ReceiveBatchToResolve[]
  receiveQuantityCounted?: boolean
  measureUnit: string
  isKg: boolean
  addresses: string[]
  notFound?: boolean
}

export interface SwapOrReturnToResolveData {
  idRequest: number
  supplierName: string
  infoReturnOptions: InfoReturnOptions | null
  invoiceNumber: number
  invoiceAccessKey: string
  idType: number
  status: string
  items: ItemToResolve[]
}

export interface StartOrDelaySwapOrReturnToResolvePayload {
  id: number
  idFulfillmentCenter?: number
  onSuccess: () => void
}

export interface ValidateSwapOrReturnToResolvePayload {
  itemId: number
  productBarcode: string
  registerBarcode: boolean
  onSuccess: () => void
  onError: (message: string) => void
}

export interface CountedBatchToReturn {
  idRequestItemBatch: number
  quantity: number
  expirationBatches: ExpirationBatchToResolve[]
}

export interface CountBatchesToReturnPayload {
  idItem: number
  batches: CountedBatchToReturn[]
}

export interface CountBatchesToReturnSagaPayload extends CountBatchesToReturnPayload {
  onSuccess: () => void
  onError: () => void
}

export interface SwapAddOrRemoveReceiveBatchesToPrintData {
  idBatch: number
  batchNumber: number
  dueDate: Date
  quantity: number
  isDirectGondola: boolean
  address: string
  entryDateAndHour: Date
}

export interface SwapAddOrRemoveReceiveBatchesPayload {
  idItem: number
  idModel: number
  barcode: string
  receiveBatches: ReceiveBatchToResolve[]
  onSuccess: (data: SwapAddOrRemoveReceiveBatchesResponseData) => void
  onError: () => void
}

export interface SwapAddOrRemoveReceiveBatchesResponseData {
  idItem: number
  fulfillmentCenter: string
  idModel: number
  productCode: string
  productDescription: string
  productBarcode: string
  measureUnit: string
  operator: string
  batches: ReceiveBatchToResolve[]
  batchesToPrint: SwapAddOrRemoveReceiveBatchesToPrintData[]
}

export interface UpdateItemBatchesToReceivePayload {
  idItem: number
  batches: ReceiveBatchToResolve[]
}

export interface FinishSwapOrReturnToResolvePayload {
  idRequest: number
  idsRequests: number[]
  onSuccess: (allFinished: boolean, pendings: PendingData[]) => void
  onError: () => void
}

export enum CountTypeEnum {
  RETURN = 'retornar',
  RECEIVE = 'receber',
}

export interface SwapOrReturnToResolveItemNotFoundPayload {
  itemId: number
  onSuccess: () => void
}

export interface SetBatchesPayload {
  batches: ReceivementBatch[]
  idModel: number
  inputQuantity: number
}

export interface ValidateRequestsToResolvePayload {
  idsRequests: number[]
  onSuccess: () => void
  onError: () => void
}

export interface ValidateSupplierReleasePayload {
  idCurrentRequest: number
  idsSelectedRequests: number[]
  onSuccess: (idsRequestsWaitingRelease: number[]) => void
  onError: () => void
  hideErrorMessage: boolean
}

export interface PendingData {
  idReceivement?: number
  idRequest?: number
  done?: boolean
}

export interface PendingsToPrint {
  supplierName: string
  pendings: PendingData[]
}

export interface ReleaseReturnRequestPayload {
  idRequest: number
  onSuccess: () => void
}
